import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import SignUp from '../../containers/SignUp';

document.addEventListener('DOMContentLoaded', () => {
  render(
    <BrowserRouter>
      <SignUp />
    </BrowserRouter>,
    document.querySelector('#root'),
  );
});
